import React, { useState } from 'react'

import { isEmpty } from 'lodash'
import { Box, Typography } from '@material-ui/core'

import { useForm } from 'react-hook-form'

import { FormAccessData } from 'components/PreRegistration'
import { LoadingFeedback } from 'components'
import { AddressForm } from '../'
import { MainForm } from './components'

import useSubscription from 'hooks/useSubscription'
import useSnackbar from 'hooks/useSnackbar'

import { TOKEN_PRE_REGISTRATION } from 'service/constants'
import constants from 'constants/index'
import * as service from 'service'

import helpers from 'helpers'
import schema from './schema'

const FormCompany = () => {
  const { DEFAULT_DDI } = constants.countries
  const {
    coupon,
    currentKind,
    data,
    isDemoSubscription,
    recaptcha,
    resetRecaptcha,
    responsibleData,
    selectedPlan,
    selectedSegment,
    setData,
    setValidForm,
    toNextStep,
    setCurrentDocument,
  } = useSubscription()
  const [inputTimeout, setInputTimeout] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const isEdit = localStorage.getItem(TOKEN_PRE_REGISTRATION) && data
  const isCompany = data?.kind === 'C' || !!data?.cnpj
  const formMethods = useForm({
    reValidateMode: 'onBlur',
    validationSchema: schema(isDemoSubscription),
    defaultValues: {
      name: isCompany ? data?.name || '' : '',
      fantasyName: isCompany ? data?.fantasyName || '' : '',
      cnpj: isCompany ? helpers.formatters.cnpj(data?.document) || '' : '',
      email: isCompany ? data?.email || '' : '',
      phone: isCompany ? data?.phone || DEFAULT_DDI : DEFAULT_DDI,
      street: data?.address?.street || '',
      neighborhood: data?.address?.neighborhood || '',
      complement: data?.address?.complement || '',
      postalCode: data?.address?.postalCode || '',
      country: data?.address?.country || 'Brasil',
      state: data?.address?.state || '',
      city: data?.address?.city || '',
      number: data?.address?.number || '',
      ...(isDemoSubscription && {
        responsibleName: data?.responsibleUser?.name || '',
        responsibleEmail: data?.responsibleUser?.email || '',
        responsiblePhone: data?.responsibleUser?.phone || DEFAULT_DDI,
      }),
    },
  })

  const snackbar = useSnackbar()

  const { handleSubmit, getValues, errors, clearError, setError } = formMethods

  const verifyDocument = (value) => {
    if (inputTimeout) clearTimeout(inputTimeout)
    setInputTimeout(
      setTimeout(async () => {
        if (value === '') {
          clearError('cnpj')
          setCurrentDocument('')
          return
        }
        try {
          const cnpj = getValues('cnpj')
          await service.dponet.companies.verifyDocument(
            helpers.regex.onlyNumbersAndLetters(cnpj),
          )
          clearError('cnpj')
        } catch ({ response }) {
          if (response?.status === 404) {
            clearError('cnpj')
          } else {
            setError('cnpj', {
              type: {
                notMatch:
                  response?.data?.error?.message ||
                  'Este documento já está em uso, portanto não é possível realizar a contratação.',
              },
            })
          }
          setCurrentDocument(getValues('cnpj'))
        }
      }, 1250),
    )
  }

  const mountPreRegistrationParams = () => {
    const values = getValues()
    const couponValue = coupon?.value || coupon?.code || coupon || ''

    return {
      preRegistration: {
        recaptcha,
        name: values?.name,
        fantasyName: values?.fantasyName,
        discountCouponCode: couponValue,
        document: values?.cnpj,
        kind: currentKind,
        phone: values?.phone || DEFAULT_DDI,
        email: values?.email,
        plan_id: selectedPlan?.id,
        type: constants.preRegistrations.REAL_TYPE,
        membership_registration: isDemoSubscription && {
          segmentId: selectedSegment,
        },
        address: {
          postal_code: values?.postalCode,
          country: values?.country || 'Brasil',
          state: values?.state,
          city: values?.city,
          complement: values?.complement,
          neighborhood: values?.neighborhood,
          street: values?.street,
          number: values?.number,
        },
        responsibleUser: {
          name: values?.responsibleName,
          phone: values?.responsiblePhone || DEFAULT_DDI,
          email: values?.responsibleEmail,
          ...responsibleData,
        },
      },
    }
  }

  const handleSubmitAction = async () => {
    try {
      setIsLoading(true)
      if (!isEmpty(errors) || !currentKind || !selectedPlan) {
        setValidForm(false)
        if (!selectedPlan) {
          snackbar.open({
            message: 'Por favor, selecione um plano para sua empresa.',
            variant: 'error',
          })
          return
        }
        snackbar.open({
          message: 'Erro ao realizar o pré-cadastro.',
          variant: 'error',
        })
      } else {
        setValidForm(true)

        const payload = mountPreRegistrationParams()
        var response

        if (isEdit) {
          response = await service.dponet.preRegistrations.put(payload)
        } else {
          response = await service.dponet.preRegistrations.create(payload)
        }

        if (!isEdit)
          localStorage.setItem(
            TOKEN_PRE_REGISTRATION,
            response?.data?.preRegistration?.token,
          )

        setData(response?.data?.preRegistration)
        toNextStep()
      }
    } catch (error) {
      resetRecaptcha()
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro, tente novamente mais tarde.',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit(handleSubmitAction)} id="form-submit-main">
      <LoadingFeedback open={isLoading} />
      <Box mb={2.5}>
        <Typography variant="h5">Dados cadastrais</Typography>
      </Box>
      <MainForm formMethods={formMethods} verifyDocument={verifyDocument} />
      <Box mt={5} mb={2.5}>
        <Typography variant="h5">Endereço</Typography>
      </Box>
      <AddressForm formMethods={formMethods} />
      {isDemoSubscription && (
        <FormAccessData isDemoSubscription demoFormMethods={formMethods} />
      )}
    </form>
  )
}

export default FormCompany
